import axios from '@/plugins/http/axios.js';
import config from "@/views/bonus/config/bonus_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);


export const service = {
    getAllBonus : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/bond`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    deleteBond: (idGroup,idEmpresa, idUsuario, formData) => {
        return axios({
            method: 'delete',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/bond`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            },
            data: formData
        })
    },
    
    postCreateProducts: ({ idGroup, idEmpresa, idUsuario, data }) => {
    
        return axios.post(
             `${config.baseUrl + _pathUri.generateUri() + idGroup}/productos/assignProduct`,
           
                    data,
          
             {
                 headers: {
                     'Content-Type': 'application/json',
                     'idEmpresa': idEmpresa,
                     'idUsuario': idUsuario
                 }
             }
         )
     },
}
